// extracted by mini-css-extract-plugin
export var error404ContentWrapper = "_404-module--error404-content-wrapper--f0d36";
export var homepagelink = "_404-module--homepagelink--eaefb";
export var searchContainer = "_404-module--search-container--f5193";